import React, { useEffect, useState } from "react";
import EventForm from "../../components/events/EventForm";
import { useParams } from "react-router-dom";
import { ReEvent } from "../../interfaces/types";
import { useCustomThemeContext } from "../../providers/customThemeProvider";
import { Box, CircularProgress, Container, Typography } from "@mui/material";
import { useEventContext } from "../../providers/EventProvider";

const EditEventPage: React.FC = () => {
  const { eventId } = useParams();
  const { getEventById } = useEventContext();
  const { updateTheme } = useCustomThemeContext();
  const [event, setEvent] = useState<ReEvent>();

  useEffect(() => {
    if (eventId) {
      const fetchedEvent = getEventById(eventId);
      setEvent(fetchedEvent);
    }
  }, [eventId, getEventById]);

    useEffect(() => {
      if (event) {
        updateTheme(event);
      } else {
        updateTheme();
      }
    }, [event]);

  return (
    <Container disableGutters>
      {/* Display the page title */}
      <Typography variant="h4" align={"center"}>
        Edit Event
      </Typography>
      {/* Render the EventForm component with edit mode enabled */}
      {!event && <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "50vh" }}>
        <CircularProgress/>
        </Box>}
      {event && <EventForm editForm submitButtonText="Update Event" event={event} />}
    </Container>
  );
};

export default EditEventPage;
